export default __webpack_public_path__ + "9c696441a4b5d03ce7d3d9a6760b7fd4.jpg";